// extracted by mini-css-extract-plugin
export var actionButton = "_j4-t";
export var buttonContainer = "_j4-0";
export var buttonContainer2 = "_j4-1";
export var buttonSection = "_j4-2";
export var details = "_j4-3";
export var dropdownItem = "_j4-5";
export var dropdownItemsContainer = "_j4-4";
export var fileInput = "_j4-r";
export var headerButton = "_j4-6";
export var icon = "_j4-7";
export var input = "_j4-8";
export var macroListItem = "_j4-9";
export var mainContent = "_j4-a";
export var microText = "_j4-b";
export var modal = "_j4-w";
export var optionsButton = "_j4-c";
export var paperclip = "_j4-s";
export var pillContent = "_j4-d";
export var preview = "_j4-e";
export var preview2 = "_j4-f";
export var quillEditor = "_j4-q";
export var selectedMacro = "_j4-g";
export var sidebar = "_j4-h";
export var sidebarHeader = "_j4-j";
export var sidebarList = "_j4-i";
export var sidebarListItem = "_j4-k";
export var sidebarSearch = "_j4-l";
export var snoozeDurationWrapper = "_j4-v";
export var statusPillContainer = "_j4-m";
export var tagsContainer = "_j4-n";
export var unselectedMacro = "_j4-o";
export var variable = "_j4-u";
export var wrapper = "_j4-p";